"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observers = void 0;
const notifier_1 = require("./notifier");
/**
 * A collection of observer callbacks.
 */
class Observers {
    constructor(name) {
        this.name = name;
        this.callbacks = { immediate: null, latent: null };
    }
    add(callback, options) {
        var _a;
        var _b;
        const schedule = (options === null || options === void 0 ? void 0 : options.immediate) ? 'immediate' : 'latent';
        ((_a = (_b = this.callbacks)[schedule]) !== null && _a !== void 0 ? _a : (_b[schedule] = new Set())).add(callback);
    }
    remove(callback) {
        var _a, _b;
        (_a = this.callbacks.immediate) === null || _a === void 0 ? void 0 : _a.delete(callback);
        (_b = this.callbacks.latent) === null || _b === void 0 ? void 0 : _b.delete(callback);
    }
    *callbacksOfType(type) {
        const callbacksToYield = this.callbacks[type];
        if (!callbacksToYield) {
            return;
        }
        for (const callback of callbacksToYield) {
            yield callback;
        }
    }
    hasCallbacksOfType(type) {
        var _a;
        return !!((_a = this.callbacks[type]) === null || _a === void 0 ? void 0 : _a.size);
    }
    *allCallbacks() {
        for (const cb of this.callbacksOfType('immediate')) {
            yield cb;
        }
        for (const cb of this.callbacksOfType('latent')) {
            yield cb;
        }
    }
    /**
     * Notify this Observable's callbacks.
     */
    notify() {
        notifier_1.Notifier.instance.notify(this);
    }
}
exports.Observers = Observers;
//# sourceMappingURL=observers.js.map